import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout';
import PromotionsMobile from '../Components/PromotionsMobile';

const PromotionsMobilePage = ({ user, config, cmsSourceFirebase, actions, match }) => {
    useEffect(() => {
        actions.sweepActions.getSweeps();
    }, [actions]);
    return (
        <Layout {...{ user, config, cmsSourceFirebase, actions, match }}>
            <PromotionsMobile />
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(PromotionsMobilePage);
